import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { INewsRss } from '@src/app/interfaces/news-rss.inteface';

@Injectable({
  providedIn: 'root'
})
export class NewsRssService {

  private rssUrl = '/rss-feed'; // proxy
  private posts: INewsRss[] = [];
  private itemsPerPage = 10;

  constructor(private http: HttpClient) {}

  public fetchPosts(): Observable<any[]> {
    if (this.posts.length) {
      return of(this.posts);
    }
    return this.http.get(this.rssUrl, { responseType: 'text' }).pipe(
      map((data) => {
        this.posts = this.parseXML(data);
        return this.posts;
      })
    );
  }

  private parseXML(data: string): INewsRss[] {
    const parser = new DOMParser();
    const xml = parser.parseFromString(data, 'text/xml');
    const items = Array.from(xml.querySelectorAll('item'));

    return items.map((item, index) => ({
      title: item.querySelector('title')?.textContent || '',
      description: this.stripHtml(item.querySelector('description')?.textContent || ''),
      link: item.querySelector('link')?.textContent || '',
      image: this.extractImage(item.querySelector('description')?.textContent || ''),
      pubDate: new Date(item.querySelector('pubDate')?.textContent || ''),
      id: index + 1,
    }));
  }

  private stripHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  private extractImage(html: string): string {
    const imgRegex = /<img[^>]+src="([^">]+)"/;
    const match = html.match(imgRegex);
    return match ? match[1] : '';
  }

  public getPostsByPage(page: number): Observable<INewsRss[]> {
    const start = (page - 1) * this.itemsPerPage;
    const paginatedPosts = this.posts.slice(start, start + this.itemsPerPage);
    return of(paginatedPosts);
  }

  public getTotalPages(): number {
    return Math.ceil(this.posts.length / this.itemsPerPage);
  }

}
